import { useState } from 'react';
import appointmentApi from '../../api/appointment/appointmentApi';
import { useToast } from '../../context/ToastContext';

/** Shared cancel flow: open sheet -> confirm with reason -> callback. */
export default function useCancelAppointment(onCancelled) {
  const toast = useToast();
  const [target, setTarget] = useState(null);
  const [loading, setLoading] = useState(false);

  const confirm = async (reason) => {
    setLoading(true);
    try {
      const updated = await appointmentApi.cancel(target.id, reason);
      toast.show('Appointment cancelled');
      setTarget(null);
      onCancelled?.(updated);
    } catch (e) {
      toast.show(e.message, 'error');
    }
    setLoading(false);
  };

  return { target, open: setTarget, close: () => setTarget(null), confirm, loading };
}
